import React from "react";
import PropTypes from "prop-types";

const KeyFigures = ({ data, icons }) => {
  const {
    number_of_utilities,
    nrw_average,
    extent_of_privatisation,
    sheet_utilities_total,
    sheet_utilities_accuracy,
  } = data;

  const {
    utilityIcon,
    nrwRedIcon,
    pieIcon,
    totalUtilities,
  } = icons;

  return (
    <div className="key-figures">
      <div className="title">
        Key figures
      </div>
      <div className="key-figures-data">
        <div className="figure-wrapper">
          <span className="figure-icon-wrapper">
            <img src={utilityIcon} alt="utility" className="key-figures-icon" />
          </span>
          <span className="figures">
            <span className="bold">
              {sheet_utilities_accuracy === "Estimate" && "circa "}
              {sheet_utilities_total === 0 ? "-" : sheet_utilities_total}
              {sheet_utilities_accuracy === "At least" && "+"}
            </span>
            <span>&nbsp;total number of utilities</span>
          </span>
        </div>
        <div className="figure-wrapper">
          <span className="figure-icon-wrapper">
            <img src={totalUtilities} alt="utility" className="key-figures-icon" />
          </span>
          <span className="figures">
            <span className="bold">{number_of_utilities}</span>
            <span>&nbsp;utilities in database</span>
          </span>
        </div>
        <div className="figure-wrapper">
          <span className="figure-icon-wrapper">
            <img src={nrwRedIcon} alt="utility" className="key-figures-icon" />
          </span>
          <span className="figures">
            <span className="bold">{nrw_average === -1 ? "-" : nrw_average}%</span>
            <span>&nbsp;NRW average</span>
          </span>
        </div>
        <div className="figure-wrapper">
          <span className="figure-icon-wrapper">
            <img src={pieIcon} alt="utility" className="key-figures-icon" />
          </span>
          <span className="figures">
            <span className="bold">{extent_of_privatisation}%</span>
            <span>&nbsp;private</span>
          </span>
        </div>
      </div>
    </div>
  );
};

KeyFigures.propTypes = {
  data: PropTypes.shape({}),
  icons: PropTypes.shape({})
};

export default KeyFigures;
